import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Drawer from '../shared/Drawer';
import Autocomplete from '../shared/Autocomplete';

const ManageCountriesModal = (props) => {
  const {
    open,
    onClose,
    onSubmit,
    loading,
    manufacturers = [],
    logistics = [],
    company
  } = props;

  const [countryConfig, setCountryConfig] = useState([]);

  useEffect(() => {
    if (open) {
      setCountryConfig(company?.countries.map((country) => {
        const config = company?.countryConfig?.find((c) => c.country === country);
        const manufacturerId = config?.manufacturer || null;
        const logisticsId = config?.logistics || null;

        return {
          country,
          manufacturer: manufacturers.find((m) => m.id === manufacturerId),
          logistics: logistics.find((l) => l.id === logisticsId),
        }
      }));
    }
  }, [open, company, manufacturers, logistics]);

  const handleSubmit = async () => {
    await onSubmit(countryConfig.map((config) => ({
      ...config,
      manufacturer: config?.manufacturer?.id || null,
      logistics: config?.logistics?.id || null,
    })));
    setCountryConfig([]);
  };

  const onManufacturerChange = (country, value) => {
    const config = [...countryConfig];
    const manageCountry = config.find((c) => c.country === country);
    manageCountry.manufacturer = value;
    setCountryConfig(config);
  };

  const onLogisticsChange = (country, value) => {
    const config = [...countryConfig];
    const manageCountry = config.find((c) => c.country === country);
    manageCountry.logistics = value;
    setCountryConfig(config);
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Manage Countries"
      subtitle="Mange company's administration countries"
      submitText="Save Changes"
      loading={loading}
      onSubmit={handleSubmit}
    >
      <Box sx={{ minWidth: { xs: 'auto', md: '560px' }, maxWidth: { xs: 'auto', md: '600px' } }}>
        <Grid container spacing={1}>
          {countryConfig.map((config, index) => (
            <Grid key={config.country} size={{ xs: 12 }}>
              <Box sx={{ pb: 2, borderBottom: index !== countryConfig.length - 1 ? '1px solid #eeeeee' : 'none'}}>
                <Typography sx={{ fontWeight: 'bold' }}>{config.country}</Typography>
                <Box sx={{ mt: 1 }}>
                  <Autocomplete
                    value={config.manufacturer}
                    onChange={(value) => onManufacturerChange(config.country, value)}
                    options={manufacturers}
                    label="Manufacturer"
                    getOptionLabel={(option) => option.name}
                  />
                </Box>
                <Box sx={{ mt: 1 }}>
                  <Autocomplete
                    value={config.logistics}
                    onChange={(value) => onLogisticsChange(config.country, value)}
                    options={logistics}
                    label="Logistics"
                    getOptionLabel={(option) => option.name}
                  />
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Drawer>
  );
};

export default ManageCountriesModal;
